module.exports = __webpack_public_path__ + "img/heatMap.a1765db6.png";